import { render, staticRenderFns } from "./TaskThreadChats.vue?vue&type=template&id=49c45785&"
import script from "./TaskThreadChats.vue?vue&type=script&lang=ts&"
export * from "./TaskThreadChats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports